module.exports = __webpack_public_path__ + "img/xddqkr-currency-guide-1.f48a3a90.png";